"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.schema = (0, graphql_tag_1.default) `
  scalar DateTime
  scalar Date

  type Asset {
    id: ID!
    make: String!
    model: String
    serialNumber: String!
    manufactureDate: Date
    manufactureDatePrecision: String
    purchaseDate: Date
    status: String
    notes: String
    location: String
    lotNumber: String
    assetType: AssetType
    property: Property
    attachments: [Attachment]
    propertyId: ID!
    assetTypeId: ID!
  }

  type AssetType {
    id: ID!
    name: String!
    description: String
    issueTypeId: ID!
    issueType: IssueType
  }

  type Attachment {
    id: ID!
    path: String
    fileType: String
    fileName: String
    status: String!
    url: String
    urlExpiresAt: DateTime
    displayName: String
    createdAt: DateTime
    createdByUser: User
  }

  input UserInput {
    firstName: String
    lastName: String
    profilePictureAttachmentId: Int
  }

  input UserRoleInput {
    userRoleId: Int
  }

  type UserPermission {
    id: ID!
    name: String!
    displayName: String!
    description: String!
  }

  type UserRole {
    id: ID!
    name: String!
    description: String!
    userPermissions: [UserPermission]
  }

  type ContactMethod {
    id: ID!
    type: String!
    value: String!
    verified: Boolean!
    userInvitations: [UserInvitation]
  }

  type SendbirdUser {
    user_id: String!
    nickname: String!
    profile_url: String!
    is_online: Boolean
    is_active: Boolean
    has_ever_logged_in: Boolean
    last_seen_at: Int
  }

  type ProcureUser {
    id: ID!
    userId: Int
    firstName: String
    lastName: String
    fullName: String
    workOrdersCreatedCount: Int
    usersInvitedCount: Int
    emailContactMethod: ContactMethod
    phoneContactMethod: ContactMethod
    organizationAccount: OrganizationAccount
    properties: [Property]
    userRole: UserRole
    userRoleId: Int
    status: String
    profilePictureAttachmentId: Int
    profilePictureAttachment: Attachment
    createdByUserId: Int
    createdAt: DateTime
    sendbirdUser: SendbirdUser
  }

  type User {
    id: ID!
    firstName: String
    lastName: String
    fullName: String
    procureUser: ProcureUser
    conciergeUser: ConciergeUser
  }

  input UserInvitationInput {
    firstName: String
    lastName: String
    userRoleId: Int
    propertyIds: [Int]
    contactMethodType: String
    contactMethodValue: String
  }

  type UserInvitation {
    id: ID!
    firstName: String
    lastName: String
    organizationAccountId: Int
    organizationAccount: OrganizationAccount
    invitedByUserId: Int
    invitedByUser: User
    userRoleId: Int
    userRole: UserRole
    propertyIds: [Int]
    contactMethodId: Int
    contactMethod: ContactMethod
    sentAt: DateTime
    acceptedAt: DateTime
    canceledAt: DateTime
    expiresAt: DateTime
    inviteStatus: String
    createdAt: DateTime
  }

  type NotificationCategory {
    id: ID!
    name: String
    description: String
    priority: Int
  }

  type NotificationType {
    id: ID!
    notificationCategoryId: ID!
    notificationCategory: NotificationCategory
    name: String
    description: String
    priority: Int
    pushEnabledDefault: Boolean
    textEnabledDefault: Boolean
    emailEnabledDefault: Boolean
  }

  input UserNotificationSettingInput {
    pushEnabled: Boolean
    textEnabled: Boolean
    emailEnabled: Boolean
  }

  type UserNotificationSetting {
    userId: ID!
    notificationTypeId: ID!
    notificationType: NotificationType
    pushEnabled: Boolean
    textEnabled: Boolean
    emailEnabled: Boolean
  }

  type Notification {
    id: ID!
    notificationTypeId: ID
    notificationType: NotificationType
    userId: ID
    triggeredByUserId: ID
    viewedAt: DateTime
    content: String
    createdAt: DateTime
  }

  type PageInfo {
    hasNextPage: Boolean
  }

  type PaginatedNotifications {
    pageInfo: PageInfo!
    edges: [Notification]
  }

  input OrganizationAccountInput {
    name: String!
  }

  type OrganizationAccount {
    id: ID!
    name: String!
    isTest: Boolean
    safeleaseRelationshipId: Int
    properties: [Property]
    users: [ProcureUser]
  }

  input PropertyInput {
    name: String
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
  }

  type Property {
    id: ID!
    organizationAccountId: Int
    organizationAccount: OrganizationAccount
    name: String
    fullAddress: String
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
    latitude: Float
    longitude: Float
    createdByUserId: Int
    updatedByUserId: Int
    tenantWorkOrderForm: TenantWorkOrderForm
    assets: [Asset]
  }

  type WorkOrderStatus {
    id: ID!
    name: String!
    description: String!
  }

  type WorkOrderPriority {
    id: ID!
    name: String!
    description: String!
  }

  type IssueType {
    id: ID!
    name: String!
    description: String!
  }

  type Issue {
    id: ID!
    issueType: IssueType!
    name: String!
    description: String!
    priceRangeFloor: Int
    priceRangeCeiling: Int
  }

  input WorkOrderAttachmentInput {
    attachmentId: Int
  }

  input WorkOrderWatcherInput {
    userId: Int
  }

  input WorkOrderCreateInput {
    propertyId: Int
    workOrderStatusId: Int
    assignedUserId: Int
    workOrderPriorityId: Int
    issueId: Int
    title: String
    description: String
    dueDate: Date
    propertyLocation: String
    creationStatus: String
    workOrderAttachments: [WorkOrderAttachmentInput]
    userCoordinates: CoordinatesInput
    procureVendorId: ID
    tenantWorkOrderSubmissionId: ID
  }

  input WorkOrderUpdateInput {
    propertyId: Int
    workOrderStatusId: Int
    workOrderWatcherUserIds: [Int]
    assignedUserId: Int
    workOrderPriorityId: Int
    issueTypeId: Int
    title: String
    description: String
    dueDate: Date
    propertyLocation: String
    conciergeEnabled: Boolean
    creationStatus: String
    bidsRequested: Int
    maxBudget: Float
    procureVendorId: ID
    workOrderTemplate: WorkOrderTemplateInput
    workOrderAssetIds: [Int]
  }

  type WorkOrder {
    id: ID!
    propertyId: Int
    property: Property
    workOrderStatus: WorkOrderStatus
    assignedUser: ProcureUser
    workOrderPriority: WorkOrderPriority
    issueType: IssueType
    title: String
    description: String
    dueDate: Date
    propertyLocation: String
    conciergeEnabled: Boolean
    conciergeLastEnabledAt: DateTime
    conciergeLastDisabledAt: DateTime
    completedAt: DateTime
    creationStatus: String
    createdByUser: User
    attachments: [Attachment]
    workOrderBidAttachments: [Attachment]
    workOrderWatcherUsers: [ProcureUser]
    bidsRequested: Int
    maxBudget: Float
    createdAt: DateTime
    procureVendorId: ID
    procureVendor: ProcureVendor
    workOrderTemplateId: ID
    workOrderTemplate: WorkOrderTemplate
    tenantWorkOrderSubmission: TenantWorkOrderSubmission
    assets: [Asset]
  }

  input CreateAssetInput {
    make: String!
    model: String
    serialNumber: String!
    manufactureDateDay: Int
    manufactureDateMonth: Int
    manufactureDateWeek: Int
    manufactureDateYear: Int
    manufactureDatePrecision: String
    purchaseDate: Date
    status: String
    notes: String
    location: String
    lotNumber: String
    assetTypeId: ID!
    propertyId: ID!
  }

  input UpdateAssetInput {
    make: String
    model: String
    serialNumber: String
    manufactureDateDay: Int
    manufactureDateMonth: Int
    manufactureDateWeek: Int
    manufactureDateYear: Int
    manufactureDatePrecision: String
    purchaseDate: Date
    status: String
    notes: String
    location: String
    lotNumber: String
    assetTypeId: ID
    propertyId: ID
  }

  type TenantWorkOrderSubmission {
    id: ID!
    tenantFirstName: String
    tenantLastName: String
    tenantEmail: String
    description: String
    propertyLocation: String
    submittedAt: DateTime
    defaultAssigneeUserId: ID
    tenantWorkOrderFormId: ID
  }

  type TenantWorkOrderForm {
    id: ID!
    hash: String
    enabled: Boolean
    propertyId: ID
    defaultAssigneeUserId: ID
  }

  input WorkOrderCommentAttachmentInput {
    attachmentId: Int
  }

  input WorkOrderCommentCreateInput {
    workOrderId: Int!
    content: String!
    workOrderCommentAttachments: [WorkOrderCommentAttachmentInput]
  }

  input WorkOrderCommentUpdateInput {
    content: String!
  }

  type WorkOrderComment {
    id: ID!
    workOrderId: Int!
    content: String!
    attachments: [Attachment]
    user: User
    createdAt: DateTime
  }

  input WorkOrderTemplateInput {
    propertyId: ID
    assignedUserId: ID
    workOrderPriorityId: ID
    issueId: ID
    issueTypeId: ID
    title: String
    description: String
    durationInDays: Int
    propertyLocation: String
    conciergeEnabled: Boolean
    bidsRequested: Int
    maxBudget: Float
    procureVendorId: ID
    recurrenceRule: RecurrenceRuleInput
    workOrderTemplateWatcherUserIds: [ID]
  }

  type WorkOrderTemplate {
    id: ID!
    propertyId: ID!
    assignedUserId: ID!
    workOrderPriorityId: ID!
    issueId: ID
    issueTypeId: ID!
    title: String!
    description: String!
    durationInDays: Int
    propertyLocation: String
    conciergeEnabled: Boolean
    bidsRequested: Int
    maxBudget: Float
    procureVendorId: ID
    recurrenceRuleId: ID!
    recurrenceRule: RecurrenceRule
    createdByUserId: ID!
    createdAt: DateTime
    deletedAt: DateTime
    workOrderTemplateWatcherUsers: [ProcureUser]
  }

  input RecurrenceRuleInput {
    frequency: String!
    startDate: Date
    interval: Int
    weekStartDay: Int
    count: Int
    endDate: Date
    bySetPosition: Int
    byMonth: [Int!]
    byMonthDay: [Int!]
    byYearDay: [Int!]
    byWeekNumber: [Int!]
    byWeekDay: [Int!]
  }

  type RecurrenceRule {
    id: ID!
    frequency: String!
    startDate: Date
    interval: Int
    weekStartDay: Int
    count: Int
    endDate: Date
    bySetPosition: Int
    byMonth: [Int!]
    byMonthDay: [Int!]
    byYearDay: [Int!]
    byWeekNumber: [Int!]
    byWeekDay: [Int!]
    lastOccurrenceDate: Date
    nextOccurrenceDate: Date
    lastProcessedAt: DateTime
  }

  input CoordinatesInput {
    latitude: Float!
    longitude: Float!
  }

  input UserFeedbackInput {
    rating: String!
    content: String!
  }

  type UserFeedback {
    id: ID!
    rating: String!
    content: String!
    createdByUserId: Int!
  }

  type Configuration {
    id: ID!
    name: String!
    value: String!
    valueType: String!
    lastAccessedAt: DateTime
    updatedByUserId: Int
    createdAt: DateTime!
    updatedAt: DateTime!
  }

  input UserConfigurationUpdateInput {
    configurationId: ID!
    value: String!
  }

  type UserConfiguration {
    id: ID!
    configurationId: ID!
    userId: ID!
    value: String!
    createdAt: DateTime
    updatedAt: DateTime
  }

  type ConciergeUser {
    id: ID!
    userId: Int!
    firstName: String!
    lastName: String!
    fullName: String!
    email: String!
    createdByUserId: Int
    createdAt: DateTime
  }

  input ConciergeUserInput {
    firstName: String
    lastName: String
    email: String
    password: String
  }

  input ConciergeUserInvitationInput {
    firstName: String
    lastName: String
    userRoleId: Int
    propertyIds: [Int]
    contactMethodType: String
    contactMethodValue: String
    organizationAccountId: ID!
  }

  type WorkOrderBidRequest {
    id: ID!
    workOrder: WorkOrder
    assignedConciergeUser: ConciergeUser
    status: String!
    createdByUser: User
    createdAt: DateTime
    updatedAt: DateTime
    conciergeVendorProcureRatings: [ConciergeVendorProcureRating!]
    conciergeVendorConciergeRatings: [ConciergeVendorConciergeRating!]
  }

  input WorkOrderBidRequestUpdateInput {
    assignedConciergeUserId: ID
    status: String
  }

  type ConciergeVendor {
    id: ID!
    name: String!
    description: String
    email: String
    phone: String
    status: String!
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
    url: String
    conciergeVendorContacts: [ConciergeVendorContact!]
    workOrderBids: [WorkOrderBid!]
    conciergeVendorConciergeRatings: [ConciergeVendorConciergeRating!]
    conciergeVendorProcureRatings: [ConciergeVendorProcureRating!]
    contractAttachment: Attachment
    policyAttachment: Attachment
  }

  input ConciergeVendorCreateInput {
    name: String!
    description: String
    email: String
    phone: String
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
    url: String
  }

  input ConciergeVendorUpdateInput {
    name: String
    description: String
    email: String
    phone: String
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
    url: String
    contractAttachmentId: ID
    policyAttachmentId: ID
  }

  type ConciergeVendorContact {
    id: ID!
    fullName: String!
    role: String
    email: String
    phone: String
    phoneExtension: String
  }

  input ConciergeVendorContactCreateInput {
    conciergeVendorId: ID!
    fullName: String!
    role: String
    email: String
    phone: String
    phoneExtension: String
  }

  input ConciergeVendorContactUpdateInput {
    fullName: String
    role: String
    email: String
    phone: String
    phoneExtension: String
  }

  type WorkOrderBid {
    id: ID!
    workOrderBidRequestId: ID!
    conciergeVendorId: ID!
    conciergeVendor: ConciergeVendor
    conciergeVendorContactId: ID
    conciergeVendorContact: ConciergeVendorContact
    bidCostTotal: Float
    materialsCostTotal: Float
    laborCostTotal: Float
    jobStartDate: Date
    jobEndDate: Date
    winningBid: Boolean!
    status: String
    workOrderBidRequest: WorkOrderBidRequest
    attachments: [Attachment!]!
    acceptedAt: DateTime
    declinedAt: DateTime
    acceptedByUser: User
    declinedByUser: User
    acceptedStatus: String
    publishedAt: DateTime
    notes: String
    onsiteVisitDate: Date
  }

  input WorkOrderBidCreateInput {
    workOrderBidRequestId: ID!
    conciergeVendorId: ID!
    conciergeVendorContactId: ID
    bidCostTotal: Float
    materialsCostTotal: Float
    laborCostTotal: Float
    jobStartDate: Date
    jobEndDate: Date
    winningBid: Boolean
    status: String
    publishedAt: DateTime
    onsiteVisitDate: Date
    notes: String
  }

  input WorkOrderBidUpdateInput {
    conciergeVendorContactId: ID
    bidCostTotal: Float
    materialsCostTotal: Float
    laborCostTotal: Float
    jobStartDate: Date
    jobEndDate: Date
    winningBid: Boolean
    status: String
    publishedAt: DateTime
    onsiteVisitDate: Date
    notes: String
  }

  type ConciergeVendorConciergeRating {
    id: ID!
    conciergeVendorId: ID!
    workOrderBidRequestId: ID!
    speedRespondToEstimateRequest: Int!
    speedProvideEstimateFromRequestDate: Int!
    speedScheduleApprovedJob: Int!
    speedResponsivenessToProcure: Int!
    notes: String
  }

  input ConciergeVendorConciergeRatingCreateInput {
    conciergeVendorId: ID!
    workOrderBidRequestId: ID!
    speedRespondToEstimateRequest: Int!
    speedProvideEstimateFromRequestDate: Int!
    speedScheduleApprovedJob: Int!
    speedResponsivenessToProcure: Int!
    notes: String
  }

  input ConciergeVendorConciergeRatingUpdateInput {
    speedRespondToEstimateRequest: Int
    speedProvideEstimateFromRequestDate: Int
    speedScheduleApprovedJob: Int
    speedResponsivenessToProcure: Int
    notes: String
  }

  type ConciergeVendorProcureRating {
    id: ID!
    conciergeVendorId: ID!
    workOrderBidRequestId: ID!
    speedResponsivenessToPartner: Int!
    speedCompleteWorkOnceStarted: Int!
    qualityOfWork: Int!
    qualityOfInteractions: Int!
    notes: String
  }

  input ConciergeVendorProcureRatingCreateInput {
    conciergeVendorId: ID!
    workOrderBidRequestId: ID!
    speedResponsivenessToPartner: Int!
    speedCompleteWorkOnceStarted: Int!
    qualityOfWork: Int!
    qualityOfInteractions: Int!
    notes: String
  }

  input ConciergeVendorProcureRatingUpdateInput {
    speedResponsivenessToPartner: Int
    speedCompleteWorkOnceStarted: Int
    qualityOfWork: Int
    qualityOfInteractions: Int
    notes: String
  }

  type ProcureVendorContact {
    id: ID!
    fullName: String!
    role: String
    email: String
    phone: String
    phoneExtension: String
    notes: String
  }

  input ProcureVendorContactCreateInput {
    procureVendorId: ID!
    fullName: String!
    role: String
    email: String
    phone: String
    phoneExtension: String
    notes: String
  }

  input ProcureVendorContactJoinedCreateInput {
    fullName: String!
    role: String
    email: String
    phone: String
    phoneExtension: String
    notes: String
  }

  input ProcureVendorContactJoinedUpdateInput {
    id: ID
    fullName: String!
    role: String
    email: String
    phone: String
    phoneExtension: String
    notes: String
  }

  input ProcureVendorContactUpdateInput {
    fullName: String
    role: String
    email: String
    phone: String
    phoneExtension: String
    notes: String
  }

  type ProcureVendor {
    id: ID!
    organizationAccountId: ID!
    organizationAccount: OrganizationAccount
    name: String!
    email: String
    phone: String
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
    procureVendorContacts: [ProcureVendorContact!]
    issueTypes: [IssueType!]
    properties: [Property!]
  }

  input ProcureVendorCreateInput {
    name: String!
    email: String
    phone: String
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
    propertyIds: [ID!]!
    issueTypeIds: [ID!]
    procureVendorContacts: [ProcureVendorContactJoinedCreateInput!]
  }

  input ProcureVendorUpdateInput {
    name: String
    email: String
    phone: String
    address1: String
    address2: String
    city: String
    state: String
    zipcode: String
    propertyIds: [ID!]
    issueTypeIds: [ID!]
    procureVendorContacts: [ProcureVendorContactJoinedUpdateInput!]
  }

  type Mutation {
    updateUser(input: UserInput!): ProcureUser
    updateUserRole(id: ID!, input: UserRoleInput!): ProcureUser
    removeUser(id: ID!): ProcureUser
    deleteUser(id: ID!): ProcureUser
    createUserInvitations(input: [UserInvitationInput]): [UserInvitation]
    updateUserNotificationSetting(
      notificationTypeId: ID!
      input: UserNotificationSettingInput!
    ): UserNotificationSetting
    createOrganizationAccount(input: OrganizationAccountInput!): OrganizationAccount
    updateOrganizationAccount(id: ID!, input: OrganizationAccountInput!): OrganizationAccount
    deleteOrganizationAccount(id: ID!): OrganizationAccount
    createProperty(input: PropertyInput!): Property
    updateProperty(id: ID!, input: PropertyInput!): Property
    deleteProperty(id: ID!): Property
    createWorkOrder(input: WorkOrderCreateInput!): WorkOrder
    updateWorkOrder(id: ID!, input: WorkOrderUpdateInput!): WorkOrder
    deleteWorkOrder(id: ID!, cascadeToWorkOrderTemplate: Boolean): WorkOrder
    createWorkOrderComment(input: WorkOrderCommentCreateInput!): WorkOrderComment
    updateWorkOrderComment(id: ID!, input: WorkOrderCommentUpdateInput!): WorkOrderComment
    deleteWorkOrderComment(id: ID!): WorkOrderComment
    createUserFeedback(input: UserFeedbackInput!): UserFeedback
    createProcureVendor(input: ProcureVendorCreateInput!): ProcureVendor
    updateProcureVendor(id: ID!, input: ProcureVendorUpdateInput!): ProcureVendor
    deleteProcureVendor(id: ID!): ProcureVendor
    createProcureVendorContact(input: ProcureVendorContactCreateInput!): ProcureVendorContact
    updateProcureVendorContact(
      id: ID!
      input: ProcureVendorContactUpdateInput!
    ): ProcureVendorContact
    updateUserConfiguration(input: UserConfigurationUpdateInput!): UserConfiguration
    deleteProcureVendorContact(id: ID!): ProcureVendorContact
    createAsset(input: CreateAssetInput!): Asset
    updateAsset(id: ID!, input: UpdateAssetInput!): Asset
    deleteAsset(id: ID!): Asset

    conciergeUpdateUser(input: ConciergeUserInput!): ConciergeUser
    conciergeDeleteUser(id: ID!): ConciergeUser
    conciergeCreateUserInvitations(input: [ConciergeUserInvitationInput]): [UserInvitation]
    conciergeUpdateWorkOrderBidRequest(
      id: ID!
      input: WorkOrderBidRequestUpdateInput!
    ): WorkOrderBidRequest
    conciergeUpdateWorkOrder(id: ID!, input: WorkOrderUpdateInput!): WorkOrder
    conciergeCreateWorkOrderComment(input: WorkOrderCommentCreateInput!): WorkOrderComment
    conciergeUpdateWorkOrderComment(id: ID!, input: WorkOrderCommentUpdateInput!): WorkOrderComment
    conciergeDeleteWorkOrderComment(id: ID!): WorkOrderComment
    conciergeCreateWorkOrderBid(input: WorkOrderBidCreateInput!): WorkOrderBid
    conciergeUpdateWorkOrderBid(id: ID!, input: WorkOrderBidUpdateInput!): WorkOrderBid
    conciergeDeleteWorkOrderBid(id: ID!): WorkOrderBid
    conciergeCreateConciergeVendor(input: ConciergeVendorCreateInput!): ConciergeVendor
    conciergeUpdateConciergeVendor(id: ID!, input: ConciergeVendorUpdateInput!): ConciergeVendor
    conciergeDeleteConciergeVendor(id: ID!): ConciergeVendor
    conciergeCreateConciergeVendorContact(
      input: ConciergeVendorContactCreateInput!
    ): ConciergeVendorContact
    conciergeUpdateConciergeVendorContact(
      id: ID!
      input: ConciergeVendorContactUpdateInput!
    ): ConciergeVendorContact
    conciergeDeleteConciergeVendorContact(id: ID!): ConciergeVendorContact
    conciergeCreateConciergeVendorConciergeRating(
      input: ConciergeVendorConciergeRatingCreateInput!
    ): ConciergeVendorConciergeRating
    conciergeUpdateConciergeVendorConciergeRating(
      id: ID!
      input: ConciergeVendorConciergeRatingUpdateInput!
    ): ConciergeVendorConciergeRating
    conciergeDeleteConciergeVendorConciergeRating(id: ID!): ConciergeVendorConciergeRating
    conciergeCreateConciergeVendorProcureRating(
      input: ConciergeVendorProcureRatingCreateInput!
    ): ConciergeVendorProcureRating
    conciergeUpdateConciergeVendorProcureRating(
      id: ID!
      input: ConciergeVendorProcureRatingUpdateInput!
    ): ConciergeVendorProcureRating
    conciergeDeleteConciergeVendorProcureRating(id: ID!): ConciergeVendorProcureRating
    conciergeCreateAsset(input: CreateAssetInput!): Asset
    conciergeUpdateAsset(id: ID!, input: UpdateAssetInput!): Asset
    conciergeDeleteAsset(id: ID!): Asset
  }

  type Query {
    me: ProcureUser
    getUserById(id: ID!): ProcureUser
    getUsersWithFilters(
      propertyIds: [ID]
      userRoleIds: [ID]
      userIds: [ID]
      getSendbirdUsers: Boolean
    ): [ProcureUser]
    getUserRoles: [UserRole]
    getUserInvitations(isPendingOnly: Boolean): [UserInvitation]
    getUserNotificationSettings: [UserNotificationSetting]
    getNotifications(offset: Int, limit: Int): [Notification]
    getOrganizationAccount: OrganizationAccount
    getPropertyById(id: ID!): Property
    getProperties: [Property]
    getWorkOrderStatuses: [WorkOrderStatus]
    getWorkOrderPriorities: [WorkOrderPriority]
    getIssueTypes: [IssueType]
    getIssues: [Issue]
    getWorkOrderById(id: ID!): WorkOrder
    getWorkOrdersWithFilters(
      propertyIds: [ID]
      workOrderStatusIds: [ID]
      assigneeUserIds: [ID]
      workOrderPriorityIds: [ID]
      issueTypeIds: [ID]
      createdByIds: [ID]
      procureVendorIds: [ID]
      createdAtStart: Date
      createdAtEnd: Date
      dueDateStart: Date
      dueDateEnd: Date
      searchText: String
      sortBy: String
      creationStatus: String
      dateRangeStart: Date
      dateRangeEnd: Date
      isRecurring: Boolean
      isTenantCreated: Boolean
      isConciergeEnabled: Boolean
    ): [WorkOrder]
    getWorkOrderCommentById(id: ID!): WorkOrderComment
    getWorkOrderCommentsByWorkOrderId(workOrderId: ID!): [WorkOrderComment]
    getProcureVendorsWithFilters(issueTypeIds: [ID], propertyIds: [ID]): [ProcureVendor]
    getProcureVendorById(id: ID!): ProcureVendor
    getProcureVendorContactsByProcureVendorId(procureVendorId: ID!): [ProcureVendorContact]
    getProcureVendorContactById(id: ID!): ProcureVendorContact
    getConfigurations: [Configuration]
    getWorkOrderBidsByWorkOrderId(workOrderId: ID!): [WorkOrderBid]
    getWorkOrderBidById(id: ID!): WorkOrderBid
    getAssetById(id: ID!): Asset
    getAssetTypes: [AssetType]
    getAssetsWithFilters(propertyIds: [ID], issueTypeIds: [ID]): [Asset]

    conciergeMe: ConciergeUser
    conciergeGetUserById(id: ID!): ConciergeUser
    conciergeGetUsers: [ConciergeUser]
    conciergeGetWorkOrderBidRequestsWithFilters(
      status: String
      workOrderStatusIds: [ID!]
      assignedConciergeUserId: ID
      organizationAccountId: ID
      conciergeVendorId: ID
      needsReview: Boolean
    ): [WorkOrderBidRequest]
    conciergeGetWorkOrderBidRequestById(id: ID!): WorkOrderBidRequest
    conciergeGetWorkOrderBidById(id: ID!): WorkOrderBid
    conciergeGetWorkOrderBidsByBidRequestId(id: ID!): [WorkOrderBid]
    conciergeGetWorkOrderBidsByConciergeVendorId(id: ID!): [WorkOrderBid]
    conciergeGetWorkOrderCommentsByWorkOrderId(workOrderId: ID!): [WorkOrderComment]
    conciergeGetConciergeVendorById(id: ID!): ConciergeVendor
    conciergeGetConciergeVendorsWithFilters(
      radius: Int
      city: String
      state: String
      address1: String
      address2: String
    ): [ConciergeVendor]
    conciergeGetConciergeVendorContactById(id: ID!): ConciergeVendorContact
    conciergeGetConciergeVendorContactsByConciergeVendorId(
      conciergeVendorId: ID!
    ): [ConciergeVendorContact]
    conciergeGetConciergeVendorConciergeRatingsByConciergeVendorId(
      conciergeVendorId: ID!
    ): [ConciergeVendorConciergeRating]
    conciergeGetConciergeVendorProcureRatingsByConciergeVendorId(
      conciergeVendorId: ID!
    ): [ConciergeVendorProcureRating]
    conciergeGetConciergeVendorProcureRatingsByWorkOrderBidRequestId(
      workOrderBidRequestId: ID!
    ): [ConciergeVendorProcureRating]
    conciergeGetConciergeVendorConciergeRatingsByWorkOrderBidRequestId(
      workOrderBidRequestId: ID!
    ): [ConciergeVendorConciergeRating]
    conciergeGetAssetById(id: ID!): Asset
    conciergeGetAssetsByPropertyId(propertyId: ID!): [Asset]
    conciergeGetAssetTypes: [AssetType]
    conciergeGetPropertyById(id: ID!): Property
    conciergeGetOrganizationAccountById(id: ID!): OrganizationAccount
    conciergeGetOrganizationAccounts: [OrganizationAccount]
  }
`;
//# sourceMappingURL=schema.graphql.js.map